<template>
  <section id="lineaServicios">
    <div class="row max-width-md section-title">
      <div class="col-12">
        <h1>Conócenos un poco más</h1>
        <p>
          TORBEL es una empresa especializada en asesoría en consultoría ambiental y en el diseño y ejecución
          de proyectos de iluminación LED e infraestructura visual, dirigidos a empresas y grupos corporativos.
        </p>
      </div>
    </div>

    <div class="services">
      <!-- First Service (Formerly Third) -->
      <article class="services__line">
        <div class="services__line__preview">
          <img
            class="services__line__preview__img"
            src="/images/pic-ambiental-home.jpg"
          />
          <div class="services__line__preview__title">
            <img
              alt="Icono Sistemas de Iluminación LED"
              src="../../../assets/images/ic-gestion-ambiental.png"
              class="services__line__preview__title__icon"
            />
            <h5 class="services__line__preview__title__text">
              Asesoría en Consultoría Ambiental
            </h5>
          </div>
        </div>

        <section class="services__line__content">
            <p>
              Ofrecemos servicios especializados de Asesoría y Consultoría
              Ambiental, respaldados por más de 20 años de experiencia,
              orientados a garantizar el cumplimiento de la legislación
              ambiental y la adecuada gestión de los riesgos ambientales de su
              organización, ante el Ministerio de Medio Ambiente y demás
              organismos competentes.
            </p>

            <p>
              Nuestro enfoque combina experiencia técnica y estratégica, con una
              gestión ágil y eficiente, permitiendo reducir riesgos regulatorios
              y asegurar el cumplimiento ambiental de forma costo-efectiva y
              oportuna.
            </p>

            <p>
              Nuestros servicios, para proyectos nuevos y operaciones en marcha,
              incluyen:
            </p>

            <button
              class="btn btn-link services__more"
              type="button"
              @click="showAmbientalMore = !showAmbientalMore"
            >
              {{ showAmbientalMore ? 'Ver menos' : 'Ver más' }}
            </button>

            <transition name="fade">
              <div v-show="showAmbientalMore">
                <ul>
                  <li>
                    Estudios de Impactos Ambientales que aseguren el cumplimiento de
                    la normativa ambiental.
                  </li>
                  <li>
                    Informes de Cumplimiento Ambiental (ICA’s): Evaluación del
                    desempeño ambiental de la operación conforme a las
                    autorizaciones vigentes.
                  </li>
                  <li>
                    Mediciones de Calidad Ambiental: Monitoreos de aire, ruido y
                    agua con metodologías confiables y auditables.
                  </li>
                  <li>
                    Gestión y trámite de Permisos Ambientales ante el Ministerio de
                    Medio Ambiente, optimizando tiempos y asegurando procesos
                    exitosos.
                  </li>
                  <li>
                    Informes de Análisis de Riesgos (IAR) para la evaluación de
                    riesgos operacionales, acorde a las regulaciones del Ministerio
                    de Industria y Comercio.
                  </li>
                  <li>
                    Planes de Seguridad y Salud en el Trabajo (PSST) y
                    acompañamiento para certificación ante el Ministerio de
                    Trabajo.
                  </li>
                </ul>

                <p><strong>Nuestra Propuesta de Valor</strong></p>
                <ul>
                  <li>Más de dos décadas apoyando empresas en el cumplimiento ambiental</li>
                  <li>Soluciones basadas en criterios técnicos sólidos y normativa vigente</li>
                  <li>Gestión ágil ante las autoridades regulatorias</li>
                  <li>Soluciones orientadas a resultados y cumplimiento efectivo</li>
                </ul>

                <p>
                  Nuestro compromiso es ser su aliado técnico en la gestión
                  ambiental y el cumplimiento regulatorio, aportando seguridad,
                  eficiencia y confianza en cada etapa de sus operaciones.
                </p>
              </div>
            </transition>
        </section>
      </article>
      <!-- ./First Service -->

      <!-- Third Service (Formerly First) -->
      <article class="services__line">
        <div class="services__line__preview">
          <img
            class="services__line__preview__img"
            src="/images/pic-iluminacion3.png"
          />
          <div class="services__line__preview__title">
            <img
              alt="Icono Sistemas de Iluminación LED"
              src="../../../assets/images/ic-iluminacion.png"
              class="services__line__preview__title__icon"
            />
            <h5 class="services__line__preview__title__text">
              Sistemas de Iluminación LED
            </h5>
          </div>
        </div>

        <section class="services__line__content">
            <p>
              Desarrollamos soluciones de iluminación que combinan diseño
              especializado y suministro de luminarias LED para proyectos
              industriales y comerciales, enfocadas en maximizar el desempeño
              en entornos exigentes, de alta complejidad y riesgo, garantizando
              eficiencia operativa, durabilidad y estándares internacionales de
              calidad.
            </p>

            <p>
              Contamos con alianzas estratégicas y el respaldo tecnológico de
              compañías norteamericanas líderes como CREE, Current-Hubbell y
              Green Creative, lo que nos permite ofrecer tecnología de vanguardia
              y soluciones confiables para cada proyecto.
            </p>
        </section>
      </article>
      <!-- ./Third Service -->

      <!-- Second Service (Formerly Third) -->
      <article class="services__line">
        <div class="services__line__preview">
          <img
            class="services__line__preview__img"
            src="/images/pic-infraestructura-2.png"
          />

          <div class="services__line__preview__title">
            <img
              alt="Icono Infraestructura Visual"
              src="../../../assets/images/ic-infraestructura.png"
              class="services__line__preview__title__icon"
            />
            <h5 class="services__line__preview__title__text">
              Infraestructura Visual
            </h5>
          </div>
        </div>

          <section class="services__line__content text-justify">
            <p>
              Realizamos el diseño, suministro e instalación de letreros
              exteriores luminosos para proyectos e instalaciones existentes.
              Trabajamos para empresas nacionales y multinacionales cuyos
              estándares responden a calidad mundial en alianza con la empresa
              Neón Nieto de Costa Rica.
            </p>
        </section>
      </article>
      <!-- ./Second Service -->
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionServicios',
  data() {
    return {
      showAmbientalMore: false
    };
  }
};
</script>

<style lang="scss" scoped>
.services {
  display: flex;

  a {
    color: $gray;
  }

  a:hover {
    text-decoration: none;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }

  &__line {
    position: relative;
    flex: 1;

    @media (max-width: 767px) {
      flex-direction: column;
    }

    &__preview {
      cursor: default;

      &__img {
        width: 100%;
      }

      &__title {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1.5rem 2rem;
        text-align: center;
        flex-direction: column;

        &__icon {
          margin: 10px 0;
          height: 54px;
        }

        &__link {
          font-size: 14px;
          font-weight: 500;
          text-align: center;
          color: $gray;
          display: flex;
          flex-direction: column;
          align-items: center;
          line-height: 1.1;

          i {
            margin-top: 6px;
          }

          &:hover {
            color: $gray;
          }
        }
      }
    }

    &__content {
      display: flex;
      justify-content: center;
      margin: 10px 0;
      padding: 1rem 2rem;
      flex-direction: column;
      justify-content: center;
      font-size: $extra-small-font-size;
      transition: background-color 0.5s;

      p {
        height: auto;
      }

      ul {
        padding-left: 20px;
      }

      .services__more {
        padding: 0;
        margin: 0 0 0.75rem;
        font-size: $extra-small-font-size;
        font-weight: 600;
        text-decoration: underline;
        color: $light--blue;
        align-self: center;

        &:hover {
          text-decoration: none;
        }
      }
    }

    &:hover {
      color: $gray;
    }
  }
}

.visible-content {
  .services__line__preview__title {
    padding: 1rem 2rem 0rem 2rem;
  }

  .services__line__content {
    padding-top: 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
